<ion-header class="balanced-title-header title-content-gap ion-no-border">
  <ion-toolbar class="header_toolbar">
    <div class="balanced-title-row">
      <ion-back-button class="balanced-title-back" defaultHref="/login" icon="chevron-back-outline" text=""></ion-back-button>
      <h1 class="balanced-title">Forgotten password</h1>
    </div>
  </ion-toolbar>
</ion-header>

<ion-content class="content-padding">
  <form class="login-form-form" #userForm="ngForm"  padding>
    <ion-list class="login-form-list">
      <h4 class="input-pseudo-label">Please enter your email</h4>
      <div class="item-wrapper">
        <ion-item class="login-form-item" no-lines>
          <ion-label position="stacked">Email</ion-label>
          <ion-input type="email"
                     [(ngModel)]="account.email"
                     name="email"
                     #userEmail="ngModel"
                     required
                     email
                     placeholder="Please enter your email"
                     class="login-form-input"
                     [ngClass]="{'is-invalid':userEmail.errors && userEmail.touched}"
                     minlength="5">
          </ion-input>
        </ion-item>
      </div>
    </ion-list>
  </form>
</ion-content>

<ion-footer class="onboarding-footer">
  <ion-toolbar>
    <div  class="sign-up-button ion-text-center">
      <ion-button expand="block" class="submit-button" (click)="doReminder()" [disabled]="userEmail.errors || isSubmitting">Submit</ion-button>
    </div>
  </ion-toolbar>
</ion-footer>
